import { useState, type InputHTMLAttributes } from "react";
/** 仅移除整数的小数尾零，不舍入、不改变原始草稿。 */
function formatEntryNumber(value: string): string {
  return value.replace(/^([+-]?\d+)\.0+$/, "$1");
}

type Props = Omit<InputHTMLAttributes<HTMLInputElement>, "value"> & { value: string };

/** 回填和失焦时简化整数；编辑时沿用唯一草稿，允许连续输入小数点和尾零。 */
export function QuoteBudgetEntryNumberInput({ value, onChange, onBlur, ...props }: Props) {
  const [editing, setEditing] = useState(false);
  return <input {...props} className={["qb-entry-native-input", props.className].filter(Boolean).join(" ")} value={editing ? value : formatEntryNumber(value)}
    onChange={event => { setEditing(true); onChange?.(event); }}
    onBlur={event => { setEditing(false); onBlur?.(event); }} />;
}
